export default __webpack_public_path__ + "static/media/capacitación_blanco.2bd61173.png";